import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import KPIListItem from "../KPIListItem";
import ChatModal from "../ChatModal";
import Chat from "../ChatComponent";
import EmptyData from "../EmptyData";

import "./style.scss";

function KPIsList({ items, kpiTypes }) {
  const [openChat, setOpenChat] = useState(false);
  const [kpiId, setKPIId] = useState(0);

  if (!items?.length > 0)
    return <EmptyData title={<FormattedMessage id="no-data" />} />;
  return (
    <div className="kpi-list-content">
      {items.map((item, i) => (
        <KPIListItem
          key={item?.ID}
          data={item}
          kpiTypes={kpiTypes}
          onClickChat={() => {
            setOpenChat(true);
            setKPIId(item.ID);
          }}
        />
      ))}
      {openChat ? (
        <ChatModal isOpen={openChat}>
          <Chat id={kpiId} onClose={() => setOpenChat(false)} />
        </ChatModal>
      ) : null}
    </div>
  );
}

export default KPIsList;
